const OACheckbox = ({ label, className, checked, onChange }) => {
  return (
    <label className={`flex items-center cursor-pointer ${className}`}>
      <input type="checkbox" className="hidden" checked={checked} onChange={onChange} />
      <span
        className={`w-5 h-5 flex items-center justify-center border-2 rounded-sm transition-all duration-200 ${
          checked ? "bg-oaRed border-oaRed" : "bg-white border-oaRed"
        }`}
      >
        {checked && (
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </span>
      <span className="ml-2">{label}</span>
    </label>
  );
};

export default OACheckbox;
